module.exports = __webpack_public_path__ + "img/email_img.0f11257e.png";